import styled from 'styled-components';

// 제목 섹션 컴포넌트
export const TitleWrap = styled.div`
	margin-top: 3.2rem;
	font-size: 2.4rem;
	color: var(--black);
	text-align: center;
`;
